import { FC, useState } from 'react';
import { PopUpModal } from 'shared-components';
import globalSubscriptionManagementService from 'services/subscriptionManagementService';
import { showNotification } from 'helper/common/commonFunctions';
import { ISubscriptionManagementUpdateBody } from 'interface/subscriptionManagementInterface';
import { SubscriptionStatus } from 'components/SubscriptionManagement/constant';

interface IProps {
  handleClose: () => void;
  onApiResponse: (_: boolean) => void;
  payload: ISubscriptionManagementUpdateBody | null;
}

const activeSubscriptionAction: FC<IProps> = ({
  payload,
  handleClose,
  onApiResponse,
}) => {
  const [loading, setLoading] = useState(false);
  const activeSubscription = async () => {
    if (!payload) return;
    setLoading(true);
    payload.Status = SubscriptionStatus.subscriptionStatusActive;
    const response =
      await globalSubscriptionManagementService.updateSubscription(payload);
    if (response?.status === 200) {
      showNotification('success', 'Subscription Updated Successfully');
      onApiResponse(true);
      handleClose();
    } else {
      onApiResponse(false);
    }
    setLoading(false);
  };

  return (
    <PopUpModal
      open={true}
      handleClose={handleClose}
      buttons={[
        {
          buttonType: 'negative',
          buttonLabel: 'Cancel',
          buttonFunction: () => {
            handleClose();
          },
        },
        {
          buttonType: 'positive',
          buttonLabel: 'Confirm',
          buttonFunction: () => {
            activeSubscription();
          },
          disabled: loading,
          loading,
        },
      ]}
      heading={'Confirm'}>
      <div className="popup-section">
        <p className="popup-question">
          Are you sure you want to Active subscription?
        </p>
      </div>
    </PopUpModal>
  );
};

export default activeSubscriptionAction;
